import React, { useState, useEffect } from "react";
import './MilstoneTrackerView.css'
import { useNavigate } from "react-router-dom";

const VaccinationTrackerView = ({ pediatricianId, patientId }) => {
  const [vaccines, setVaccines] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem('s2stoken')
  const navigate = useNavigate()

  useEffect(() => {
    const fetchVaccines = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/get_vaccine_tracker_doctor_view?pediatrician_id=${pediatricianId}&patient_id=${patientId}`,
          {
            method: "GET",
            credentials: "include",
            headers:{Authorization: `Bearer ${token}`}
          }
        );

        const data = await response.json();
        if (!response.ok || data.success === false) {
          throw new Error(data.message || "Failed to fetch data");
        }

        if (data.success) {
          setVaccines(
            data.data
              .filter(vaccine => vaccine["Whether Taken"] === "yes")
              .map(vaccine => ({
                ...vaccine,
                "Date When Taken": vaccine["Date When Taken"].replace(
                  /(\w{3}, \d{2} \w{3} \d{4}) \d{2}:\d{2}:\d{2} GMT/,
                  "$1"
                ).trim(),
              }))
          );
        } else {
          alert(data.message);
        }
      } catch (error) {
         if (error?.message === 'Token has expired') {
          localStorage.removeItem('s2stoken')
          navigate('/')
        }
        console.error("Error fetching vaccination data:", error);
        alert("Error fetching vaccination data.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchVaccines();
  }, [pediatricianId, patientId]);
console.log(vaccines);
  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="milestone-tracker-view">
      <h1>Vaccination Tracker</h1>
      <table>
        <thead>
          <tr>
            <th>Age Range</th>
            <th>When to Take</th>
            <th>Vaccine</th>
            <th>Date When Taken</th>
          </tr>
        </thead>
        <tbody>
          {vaccines.map((vaccine, index) => (
            <tr key={index}>
              <td data-label="Age Range">{vaccine["Age Range"]}</td>
              <td data-label="When to Take">{vaccine["When to Take"]}</td>
              <td data-label="Vaccine">{vaccine.Vaccine}</td>
              <td data-label="Date When Taken">{vaccine["Date When Taken"]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default VaccinationTrackerView;
